import { defineMessages } from 'react-intl';

export default defineMessages({
    totPerAll1: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Revenue.Total Percentage Allocated',
        defaultMessage: 'Total Percentage Allocated'
    },
    totalPercAllocatedErrorMessage: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Revenue.Revenue Section: Atleast one service is required to proceed',
        defaultMessage: 'Revenue Section: Atleast one service is required to proceed'
    },
});